// extracted by mini-css-extract-plugin
export var header = "header-small-module--header--21jNm";
export var left = "header-small-module--left--ctDgc";
export var right = "header-small-module--right--HiagU";
export var sectionContainer = "header-small-module--section-container--sTcL9";
export var subContainer = "header-small-module--sub-container--mHgcv";